import { useEffect, useState } from 'react'
import { api } from '../../shared/api'
import { tg } from '../../shared/lib/telegram'

const FIELDS: [string, string, string][] = [
  ['title', 'Название', 'Пуховик Canada Goose'],
  ['price', 'Цена, ₽', '15000'],
  ['brand', 'Бренд', 'Canada Goose'],
  ['color', 'Цвет', 'чёрный'],
  ['material', 'Материал', 'полиэстер'],
]

type FormState = Record<string, string>

export function NewItemForm({ onDone }: { onDone: () => void }) {
  const [form, setForm] = useState<FormState>({})
  const [files, setFiles] = useState<File[]>([])
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const set = (key: string) => (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) =>
    setForm({ ...form, [key]: e.target.value })
  const ready = Boolean(form.title) && !busy

  const submit = async () => {
    setBusy(true)
    setError(null)
    try {
      const item = await api.createItem({
        title: form.title,
        price: form.price ? Number(form.price) : null,
        brand: form.brand,
        color: form.color,
        material: form.material,
        description: form.description,
        // Спека для постера собирается из тех же полей: отдельной формы под неё
        // не заводим, а недостающее дозаполнит разбор описания.
        spec: {
          title: form.title,
          brand: form.brand,
          color: form.color,
          material: form.material,
          description: form.description,
        },
      })
      for (const file of files) await api.uploadPhoto(item.id, file)
      tg?.HapticFeedback?.notificationOccurred('success')
      onDone()
    } catch (e) {
      setError((e as Error).message)
      tg?.HapticFeedback?.notificationOccurred('error')
    } finally {
      setBusy(false)
    }
  }

  // Родная кнопка Telegram внизу экрана: так форма ощущается частью клиента,
  // а не веб-страницей с собственной кнопкой.
  useEffect(() => {
    const button = tg?.MainButton
    if (!button) return undefined
    button.setText(busy ? 'Сохраняем…' : 'Сохранить товар')
    button.onClick(submit)
    if (ready) button.show()
    else button.hide()
    return () => {
      button.offClick(submit)
      button.hide()
    }
  })

  return (
    <>
      {error && <div className="error">{error}</div>}
      {FIELDS.map(([key, label, hint]) => (
        <div key={key}>
          <label>{label}</label>
          <input
            value={form[key] || ''}
            placeholder={hint}
            inputMode={key === 'price' ? 'numeric' : undefined}
            onChange={set(key)}
          />
        </div>
      ))}

      <label>Описание</label>
      <textarea
        value={form.description || ''}
        onChange={set('description')}
        placeholder="Состояние, посадка, что в комплекте"
      />

      <label>Фотографии</label>
      <input
        type="file"
        accept="image/*"
        multiple
        onChange={(e) => setFiles([...(e.target.files || [])])}
      />
      {files.length > 0 && (
        <div className="thumbs">
          {files.map((file, i) => (
            <img key={i} src={URL.createObjectURL(file)} alt="" />
          ))}
        </div>
      )}
      <div className="hint">Первая фотография станет главной в объявлении.</div>

      {/* Запасная кнопка: MainButton есть не во всех версиях клиента. */}
      {!tg?.MainButton && (
        <button className="primary" disabled={!ready} onClick={submit}>
          {busy ? 'Сохраняем…' : 'Сохранить товар'}
        </button>
      )}
    </>
  )
}
